/**
 * La caja donde se suelta la planilla de luz.
 *
 * Acepta arrastrar y soltar, pero **el input de archivo sigue estando ahi debajo** y es
 * el que hace el trabajo. Un area de arrastre sin input de verdad no funciona con el
 * teclado, no funciona en un movil, y no funciona con lector de pantalla: es decoracion
 * cara. Arrastrar es el atajo, no el mecanismo.
 */

import { useRef, useState } from 'react'

const EXTENSIONES = '.jpg,.jpeg,.png,.pdf'

interface Props {
  archivo: File | null
  onCambio: (archivo: File | null) => void
  error?: string | undefined
}

export function SubirPlanilla({ archivo, onCambio, error }: Props) {
  const [encima, setEncima] = useState(false)
  const entrada = useRef<HTMLInputElement>(null)

  function soltar(evento: React.DragEvent) {
    evento.preventDefault()
    setEncima(false)
    const primero = evento.dataTransfer.files[0]
    if (primero) onCambio(primero)
  }

  if (archivo) {
    return (
      <div className="archivo-puesto">
        <span className="archivo-icono" aria-hidden="true">
          📄
        </span>
        <span className="archivo-nombre">
          {archivo.name}
          <small>{(archivo.size / 1024).toFixed(0)} KB</small>
        </span>
        <button
          type="button"
          className="boton-texto"
          onClick={() => {
            onCambio(null)
            // Sin esto, volver a elegir el MISMO archivo no dispara `change` y parece
            // que el boton no hace nada.
            if (entrada.current) entrada.current.value = ''
          }}
        >
          Quitar
        </button>
      </div>
    )
  }

  return (
    <>
      <div
        className={`zona-archivo${encima ? ' encima' : ''}${error ? ' con-error' : ''}`}
        onDragOver={(evento) => {
          evento.preventDefault()
          setEncima(true)
        }}
        onDragLeave={() => setEncima(false)}
        onDrop={soltar}
      >
        <label htmlFor="planilla" className="zona-archivo-etiqueta">
          <strong>Sube tu planilla de luz</strong>
          <span>Arrastrala aqui o pulsa para elegirla</span>
          <small>Una foto o el PDF de tu factura. JPG, PNG o PDF, hasta 10 MB.</small>
        </label>
        <input
          ref={entrada}
          id="planilla"
          type="file"
          accept={EXTENSIONES}
          onChange={(evento) => onCambio(evento.target.files?.[0] ?? null)}
          aria-describedby={error ? 'planilla-error' : undefined}
        />
      </div>
      {error && (
        <p className="error" id="planilla-error" role="alert">
          {error}
        </p>
      )}
    </>
  )
}
